<template>
    <div class="mx-auto py-3 px-4" v-if="isUserAuthenticated">
        <p class="text-center small mb-0" v-if="nome_negozio"><b>{{ this.nome_negozio }}</b></p>
    </div>
    <div class="mx-auto py-3 px-4" v-else>
        <p class="text-center small">Non loggato </p>
    </div>
</template>

<script>
import fetchComp from "@/utils/fetchComp";

import { IS_USER_AUTHENTICATED } from "@/store/overlay/const";
import store from "@/store";
import VueCookies from 'vue-cookies';

export default {
    setup() {
        const {stats} = fetchComp();
        return {
            stats
        }
    },
    data() {
        return {
        nome_negozio: '',
        isUserAuthenticated: false,
        }
    },
    methods: {
        
        async getUser() {

            setTimeout(() => {
                const seller = VueCookies.get('seller');

                if (seller && seller.nome_negozio) {
                    this.nome_negozio = seller.nome_negozio;
                } else {
                    console.warn("Il cookie 'seller' è nullo o non contiene 'nome_negozio'");
                    this.nome_negozio = 'Il cookie seller è nullo o non contiene nome_negozio'; // Valore di default
                }
            }, 1000);

                
        }
        
    },
    mounted() {

        
        if (!store.getters[`auth/${IS_USER_AUTHENTICATED}`]) {
            this.isUserAuthenticated = false;
        } else {     
            this.isUserAuthenticated = true;
           this.getUser()
            
            
        }

        
        
    }
}
</script>